import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {ProgressBar} from '../../atoms/ProgressBar/ProgressBar';
import {Text} from '../../atoms/Text/Text';

export interface MOVProps {
  className?: string;
  color?: keyof typeof COLORS;
  ['data-testid']?: string;
  height?: number;
  label: string;
  progress: number;
}

export const MOV: React.FC<MOVProps> = ({
  className,
  color = COLORS.Green3,
  'data-testid': dataTestId = 'mov',
  height = 4,
  label,
  progress,
}) => {
  return (
    <Wrapper className={className} data-testid={dataTestId}>
      <StyledProgressBar
        color={color}
        count={progress}
        height={height}
        total={1}
      />
      <Label size="px10">{label}</Label>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyledProgressBar = styled(ProgressBar)`
  flex: 0.2;
  background-color: ${COLORS.Grey2};
`;

const Label = styled(Text)`
  margin-left: 0.75rem;
  flex: 1;
`;
